module.exports = __webpack_public_path__ + "img/social_media_management.33d6b406.png";